import { HttpClient, HttpHeaders } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { BehaviorSubject, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { setFirebaseFilters } from 'src/app/global/utils';
import { environment } from 'src/environments/environment';

export interface SalePoint {
  id: string;
  nombre: string;
  bodega: string;
  zonaCobertura: string;
  lat: number;
  lng: number;
  tpv: string;
}

@Injectable({
  providedIn: 'root',
})
export class SalePointsService {
  baseURL = environment.backendUrl;
  headers: HttpHeaders = new HttpHeaders({ 'Content-Type': 'application/json' });
  private salePointsCache$ = new BehaviorSubject<SalePoint[] | null>(null);

  constructor(private http: HttpClient) { }
  /**
   * Get the sale points from firebase
   */

  getAllSalePoints(filters: any[] = [], orderBy: string = '', limit: number = 0) {

    if (this.salePointsCache$.value) {
      return of(this.salePointsCache$.value);
    }
    let params = setFirebaseFilters(filters, orderBy, limit);

    return this.http
      .get<SalePoint[]>(`${this.baseURL}collections/getCollection/puntosDeVentaIntegracion`, { params })
      .pipe(
        tap((data: SalePoint[]) => {
          this.salePointsCache$.next(data);
        })
      );
  }

  clearCache() {
    this.salePointsCache$.next(null);
  }
  getHollidays(): any {
    return this.http.get(this.baseURL + 'api/get-holiday', { headers: this.headers });
  }
}

export class SignalModalEmitterService {
  constructor() { }
  static onChange: EventEmitter<String> = new EventEmitter<String>();
  static sendSignal(signal: String) {
    this.onChange.emit(signal);
  }
}
